export const isRewardAvailable = (path) => {
    if (path === "/") return true;
    return false;
};
